import styled from "styled-components";

export const PointsStyled = styled.div<{ color: string }>`
  display: flex;
  justify-content: center;
  flex-direction: row;
  .number {
    width: 70%;
    text-align: right;
    font-size: 40px;
    line-height: 40px;
    letter-spacing: -6px;
  }
  .number, .points-label, .currency {
    font-family: Bowlby One;
    font-style: normal;
    font-weight: normal;
    padding: 4px;
    color: ${(props) => props.color};
  }
`;

export const PointsCurrencyContentStyled = styled.div`
  width: 30%;
  padding: 4px 2px;
  .points-label {
    text-transform: uppercase;
  }
  .points-label, .currency {
    display: block;
    text-align: left;
    font-size: 15px;
    line-height: 12px;
  }
`;

